import api from './api';

export const getAdminsApi = params => {
  return api.get('/users', {params});
};

export const getAdminDetailsApi = id => {
  return api.get(`users/${id}`);
};

export const addAdminApi = params => {
  return api.post('/users', params);
};

export const editAdminApi = params => {
  return api.put('/users', params);
};

export const deleteAdminApi = id => {
  return api.delete(`/users/${id}`);
};
